import { Outlet, createRootRoute } from '@tanstack/react-router'
import { ErrorBoundary } from '@/components/error-boundary'

function RootComponent() {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
})

